<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Update Email Templates</strong>
    </span>
    <span style="float:right">
      <!-- <a routerLink="/ncd-issue/add"> -->
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2 mt-0" (click)="back()" type="button">
          <i class="fa fa-chevron-circle-left"></i>&nbsp;Back</button>
      <!-- </a> -->
    </span>
  </div>
  <form [formGroup]="reminderMasterForm" class="well">
    <!-- <div class="modal-content"> -->
      <!-- <div class="modal-header">
        <h5 class="modal-title" id="reminderModalLabel">Email Templates</h5>
        <button aria-label="Close" class="close" (click)="intializeDatatable()" data-dismiss="modal"
          type="button">
          <i class="fa fa-times"></i>
        </button>
      </div> -->
      <!-- <div class="modal-body"> -->
        <div class="card-block datatable-card-block">

        <div class="row" [hidden]="!IsUpsiEmail">
          <div class="col-md-1">
            <label class="form-control-label" for="l0">To</label>
          </div>
          <div class="col-md-11">
            <div class="form-group">
              <div class="select-label">Select on of them: (Sharer, Recipient, Data entry person, ADMIN, UPSI All data)</div>
              <div class="input-container">
                <div class="selected-tags">
                  <span class="tag" *ngFor="let item of selectedToEmails">
                    {{item}}
                    <span class="tag-remove" (click)="removeToEmail(item)">×</span>
                  </span>
                </div>
                <div class="dropdown-container">
                  <input 
                    type="email" 
                    class="form-control emailTo" 
                    [class.is-invalid]="toEmailError"
                    name="emailTo" 
                    [value]="toInputValue"
                    (click)="toggleToDropdown()"
                    (keydown.enter)="onToInputEnter($event)"
                    (blur)="onToInputBlur($event)"
                    (input)="onToInputChange($event)"
                    placeholder="Type email address or select from dropdown"
                    autocomplete="off"
                    readonly>
                  <div class="custom-dropdown" *ngIf="showToDropdown">
                    <div 
                      class="dropdown-option" 
                      *ngFor="let option of filteredToOptions; trackBy: trackByOption"
                      (mousedown)="selectToOption(option)"
                      (click)="selectToOption(option)">
                      {{option}}
                    </div>
                    <div class="dropdown-option no-options" *ngIf="filteredToOptions.length === 0">
                      No options available
                    </div>
                  </div>
                  <div class="invalid-feedback" *ngIf="toEmailError" style="display: block; color: #dc3545; font-size: 12px; margin-top: 5px;">
                    {{toEmailError}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" [hidden]="!IsUpsiEmail">
          <div class="col-md-1">
            <label class="form-control-label" for="l0">CC</label>
          </div>
          <div class="col-md-11">
            <div class="form-group">
              <div class="select-label">Select on of them: (Sharer, Recipient, Data entry person, ADMIN, UPSI All data)</div>
              <div class="input-container">
                <div class="selected-tags">
                  <span class="tag" *ngFor="let item of selectedCcEmails">
                    {{item}}
                    <span class="tag-remove" (click)="removeCcEmail(item)">×</span>
                  </span>
                </div>
                <div class="dropdown-container">
                  <input 
                    type="email" 
                    class="form-control emailCC" 
                    [class.is-invalid]="ccEmailError"
                    name="emailCC" 
                    [value]="ccInputValue"
                    (click)="toggleCcDropdown()"
                    (keydown.enter)="onCcInputEnter($event)"
                    (blur)="onCcInputBlur($event)"
                    (input)="onCcInputChange($event)"
                    placeholder="Type email address or select from dropdown"
                    autocomplete="off"
                    readonly>
                  <div class="custom-dropdown" *ngIf="showCcDropdown">
                    <div 
                      class="dropdown-option" 
                      *ngFor="let option of filteredCcOptions; trackBy: trackByOption"
                      (mousedown)="selectCcOption(option)"
                      (click)="selectCcOption(option)">
                      {{option}}
                    </div>
                    <div class="dropdown-option no-options" *ngIf="filteredCcOptions.length === 0">
                      No options available
                    </div>
                  </div>
                  <div class="invalid-feedback" *ngIf="ccEmailError" style="display: block; color: #dc3545; font-size: 12px; margin-top: 5px;">
                    {{ccEmailError}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-1">
            <label class="form-control-label" for="l0">Title</label>
          </div>
          <div class="col-md-11">
            <div class="form-group">
              <input [formControl]="reminderMasterForm.controls['Title']" class="form-control" placeholder="Email Title" readonly>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1">
            <label class="form-control-label" for="l0">Subject
              <span _ngcontent-c2="" style="color: red;">*</span>
            </label>
          </div>
          <div class="col-md-11">
            <div class="form-group">
              <input [formControl]="reminderMasterForm.controls['Subject']" class="form-control" placeholder="Email Subject">
              <div *ngIf="reminderMasterForm.controls['Subject'].hasError('required') && reminderMasterForm.controls['Subject'].touched" class="form-control-error-custom">
                Email Subject is required.
              </div>
              <div *ngIf="reminderMasterForm.controls['Subject'].hasError('noSpecialCharacters')" class="form-control-error-custom">
                User Input cannot contain special characters.
              </div>
            </div>
          </div>
        </div>
        <div class="row" [hidden]="true" >
          <div class="col-md-1">
            <label class="form-control-label" for="l0">Attachment
            </label>
          </div>
          <div class="col-md-11">
            <div class="form-group">

              <input name="Attachment" class='form-control' type="file" (change)="fileChanged($event)">
            </div>
          </div>
        </div>

        <div class="row" [hidden]="true" >
          <div class="col-lg-1" *ngIf="DocumentFileDoc">
            <label class="form-control-label">Document</label>
          </div>
          <div class="col-lg-11" *ngIf="DocumentFileDoc">
            <div class="form-group">

            <a class="btn btn-sm btn-default"><span
                (click)="downloadFile()">{{FileNameO }}</span>&nbsp;<span (click)="downloadFile()"
                style="margin-left: 10px"><i class="fa fa-download"></i></span><span
                (click)="deleteFile()" style="margin-left: 10px"><i class="fa fa-close"
                  style="color: white"></i></span></a>
              </div>

          </div>
        </div>

        <div class="row" [hidden]="true">

          <div class="col-md-1">
            <label class="form-control-label" for="l0">Email Text </label>
          </div>
          <div class="col-md-11">
            <div class="form-group">

              <textarea [formControl]="reminderMasterForm.controls['EmailText']" class="form-control"
                rows="3">
              </textarea>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-1">
            <label class="form-control-label" for="l0">Body
            </label>
          </div>
          <div class="col-md-11">
            <div class="form-group">
              <div id="emailEditor" style="height: 300px; background-color: white; border: 1px solid #ccc;"></div>
            </div>
          </div>
        </div>
      <!-- </div> -->
      <div class="modal-footer">
        <button id="btnupdateReminder" style="display:none;" type="button" class="btn btn-sm btn-primary"
          [disabled]="!reminderMasterForm.valid || disabledOnclick" (click)="checKkeyWordsAlert()">
          <i class="fa fa-save"></i>&nbsp;Update
        </button>
        <button type="button" class="btn btn-sm" (click)="back()" data-dismiss="modal">
          <i class="fa fa-times"></i>&nbsp;Cancel
        </button>
      </div>
    </div>
  </form>
  <div class="modal-backdrop fade" [class.show]="showSuccessPopup" [style.display]="showSuccessPopup ? 'block' : 'none'"></div>
  <div class="modal fade" [class.show]="showSuccessPopup" [style.display]="showSuccessPopup ? 'block' : 'none'" id="saveAlert" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Success</h5>
          <button aria-label="Close" class="close" type="button" (click)="onOkFunction()">
            <span aria-hidden="true">
              <i class="fa fa-times"></i>
            </span>
          </button>
        </div>
        <div class="modal-body">
          <p>Email Template details updated successfully.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary mt-0" (click)="onOkFunction()">
            <i class="fa fa-check"></i>&nbsp;OK
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
 
